import React from 'react'
import DuplicateKeywordsGptForm from './DuplicateKeywordsGptForm'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function DuplicateKeywordsGpt() {
  SetTitle('Duplicate Keyword GPT')
  const description =
    'Una volta caricato il file, su inn-ranking.Inn_duplicati di Bigquery verrà caricato il report con le keywords duplicate. Per duplicate si intende, parole simili o insiemi di parole simili, con lo stesso volume. (Esempio: bad e bed, salotto vintage e salotti vintage).'

  return (
    <Header
      iconClass="ni ni-key-25 text-white"
      title="Duplicate Keyword GPT"
      docLink="/docs/ranking_tools/duplicate-keywords-gpt/"
      description={description}
    >
      <DuplicateKeywordsGptForm />
    </Header>
  )
}